"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDoctor = instanceOfDoctor;
exports.DoctorFromJSON = DoctorFromJSON;
exports.DoctorFromJSONTyped = DoctorFromJSONTyped;
exports.DoctorToJSON = DoctorToJSON;
/**
 * Check if a given object implements the Doctor interface.
 */
function instanceOfDoctor(value) {
    if (!('created_at' in value) || value['created_at'] === undefined)
        return false;
    if (!('deleted_at' in value) || value['deleted_at'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('professional_id' in value) || value['professional_id'] === undefined)
        return false;
    if (!('rpps' in value) || value['rpps'] === undefined)
        return false;
    if (!('speciality' in value) || value['speciality'] === undefined)
        return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined)
        return false;
    return true;
}
function DoctorFromJSON(json) {
    return DoctorFromJSONTyped(json, false);
}
function DoctorFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'created_at': json['created_at'],
        'deleted_at': json['deleted_at'],
        'id': json['id'],
        'professional_id': json['professional_id'],
        'rpps': json['rpps'],
        'speciality': json['speciality'],
        'updated_at': json['updated_at'],
    };
}
function DoctorToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'created_at': value['created_at'],
        'deleted_at': value['deleted_at'],
        'id': value['id'],
        'professional_id': value['professional_id'],
        'rpps': value['rpps'],
        'speciality': value['speciality'],
        'updated_at': value['updated_at'],
    };
}
